import { render } from "./MessageInfoModal.vue?vue&type=template&id=bbb1a22e&scoped=true"
import script from "./MessageInfoModal.vue?vue&type=script&lang=js"
export * from "./MessageInfoModal.vue?vue&type=script&lang=js"

import "./MessageInfoModal.vue?vue&type=style&index=0&id=bbb1a22e&scoped=true&lang=css"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbb1a22e"]])

export default __exports__